import type { IntlKey } from 'locales';
import { FC } from 'react';

import type { PublicationItem } from '../model';
import { SeeMorePublicationsList } from './see-more-publications-list';

interface Props {
  titleKey: IntlKey;
  items: readonly PublicationItem[];
  onClose: () => void;
}

export const SeeMorePublicationsMonoCategory: FC<Props> = ({ onClose, titleKey, items }) => (
  <div className="d-flex flex-column">
    <SeeMorePublicationsList onClose={onClose} items={items} titleKey={titleKey} />
  </div>
);

SeeMorePublicationsMonoCategory.displayName = 'SeeMorePublicationsMonoCategory';
